// extracted by mini-css-extract-plugin
export var btn = "button_orange-module--btn--21c23";
export var icon = "button_orange-module--icon--d38ce";
export var outline = "button_orange-module--outline--55ab5";
export var primary = "button_orange-module--primary--b87d8";
export var small = "button_orange-module--small--f1a8c";
export var text = "button_orange-module--text--8d786";